import React from 'react';
import { Box } from '@mui/material';
import logoImage from '../../assets/ds360-logo.png';

const Logo = ({ height = 40, ...props }) => {
  return (
    <Box
      component="img"
      src={logoImage}
      alt="DS360 Investment"
      sx={{
        height: height,
        width: 'auto',
        objectFit: 'contain',
        ...props.sx
      }}
      {...props}
    />
  );
};

export default Logo; 